import { useAuth } from 'contexts/AuthContext';

export const usePermissions = () => {
  const { user } = useAuth();
  
  const hasPermission = (permissionName) => {
    if (!user || !user.permissions) return false;
    return user.permissions.some(p => p.name === permissionName);
  };
  
  const hasAnyPermission = (permissionNames) => {
    if (!user || !user.permissions) return false;
    return user.permissions.some(p => permissionNames.includes(p.name));
  };
  
  const hasAllPermissions = (permissionNames) => {
    if (!user || !user.permissions) return false;
    return permissionNames.every(permissionName => 
      user.permissions.some(p => p.name === permissionName)
    );
  };

  const canAccessPage = (pagePermissions) => {
    return hasAnyPermission(pagePermissions);
  };

  const getUserPermissions = () => {
    if (!user || !user.permissions) return [];
    return user.permissions.map(p => p.name);
  };

  const getUserRole = () => {
    if (!user || !user.role) return null;
    return user.role;
  };
  
  return { 
    hasPermission, 
    hasAnyPermission, 
    hasAllPermissions, 
    canAccessPage,
    getUserPermissions,
    getUserRole
  };
};

